// src/components/Header.js
import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useLanguage } from '../contexts/LanguageContext';

export default function Header() {
    const { signOut } = useAuth();
    const { t, toggleLanguage, language } = useLanguage();

    return (
        <div className="flex justify-between items-center mb-8">
            {/* Logo and Title */}
            <div className="flex items-center gap-4">
                <img
                    src="/logo512.png"
                    alt="Game Logo"
                    className="w-12 h-12 rounded-lg shadow-md"
                />
                <div>
                    <h1 className="text-3xl font-bold">{t('title')}</h1>
                    {/* Android App Link */}
                    <a
                        href="https://play.google.com/store/apps/details?id=com.vecitiderbi.veciti_derbi"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center gap-2 mt-2 px-3 py-1 bg-green-600 hover:bg-green-700 rounded-lg text-sm transition-colors"
                        title={t('playAnonymously')}
                    >
                        <span>📱</span>
                        {t('downloadAndroidApp')}
                    </a>
                </div>
            </div>

            {/* Buttons */}
            <div className="flex gap-2">
                <button
                    onClick={toggleLanguage}
                    className="px-3 py-1 bg-gray-700 rounded hover:bg-gray-600 transition-colors"
                >
                    {language.toUpperCase()}
                </button>

                <button
                    onClick={signOut}
                    className="px-3 py-1 bg-red-600 rounded hover:bg-red-700 transition-colors"
                >
                    {t('logout')}
                </button>
            </div>
        </div>
    );
}